export const PROCEDURE_ROUTES = {
  index: '/workspace/:workspaceSlug/procedures',
  create: '/workspace/:workspaceSlug/procedures/new',
  edit: '/workspace/:workspaceSlug/procedures/:itemId/edit',
  portal: '/portal/:slug/knowledge/procedures'
};
